import React, { useState,useEffect } from "react";
import { useGlobalContext } from "./../component/GlobalContext";
import MemberCoupon from './../pages/Member/MemberCoupon';
import AdminCoupon from './../pages/Admin/AdminCoupon';
import VendorCoupon from "./Vendor/VendorCoupon";

function CouponMaster() {
  const { globalUserVar } = useGlobalContext();
  const [roleId, setRoleId] = useState(3);
  useEffect(() => {
    // console.log(globalUserVar)
    // console.log(typeof(globalUserVar))
    let userData;
    if(typeof(globalUserVar) == 'string') {
      userData = JSON.parse(globalUserVar); // Parse the JSON string
      setRoleId(userData.role_id);
    }
}, [globalUserVar]);

const renderComponentBasedOnRole = () => {
  switch (roleId) {
    case 1:
      return <AdminCoupon/>;
    case 2:
      return <AdminCoupon/>;
    case 3:
      return <MemberCoupon/>;
    default:
      return <div>Unauthorized Access</div>;
  }
};
  return (
    <>
      {roleId !== null ? renderComponentBasedOnRole() : <div>Loading...</div>}
    </>
  )
}

export default CouponMaster